import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  BookOutlined,
  EnvironmentOutlined,
  GlobalOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, Spin } from "antd";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { BsFacebook, BsLinkedin, BsStackOverflow, BsTelephone } from "react-icons/bs";
import { GrGithub } from "react-icons/gr";
import { AiOutlineMail } from "react-icons/ai";
import {
  getResume3d,
  removefollower,
  addfollower,
  viewIncrement,
  getOneUserSkillListing,
} from "../../redux/actions";
import Loader from "../../components/Loading/Loader";
import history from "../../routes/history";
import backButton from "../../assets/icons/backButton.svg";
import TopAlert from "../../components/TopNotification/TopAlert";
import { formatPhoneNumber, normalizeDescriptionLines } from "../../shared/helpers";
import PopupModal from "./components/PopupModal/PopupModal";
import PrivateTagSkillListing from "../../components/PrivateMarketComponents/PrivateTagSkillListing";
import IndustryDensity from "./components/IndustryDensity/IndustryDensity";
import { downloadSelectedDocumentsApi, getDocumentViewUrlApi } from "../../API/API";
import coverImage from "../../assets/img/new3d-cover.png";
import skillListingIcon from "../../assets/icons/3d-resume-skillListing-icon.svg";
import resumeIcon2 from "../../assets/icons/3d-resume-icon2.svg";
import resumeIcon3 from "../../assets/icons/3d-resume-icon3.svg";
import resumeIcon4 from "../../assets/icons/3d-resume-icon4.svg";
import resumeIcon5 from "../../assets/icons/3d-resume-icon5.svg";
import CareerHistory from "./components/CareerHistory/CareerHistory";
import Credentialing from "./components/Credentialing/Credentialing";
import SkillIndex from "./components/SkillIndex/SkillIndex";
import "./3dResume.css";

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
};

const toS3Url = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${process.env.REACT_APP_S3_URL}${path.charAt(0) !== "/" ? "/" : ""}${path}`;
};

const clampPercent = (value) => Math.min(100, Math.max(0, Number(value) || 0));

const formatDate = (date) => (date ? moment(date).format("MMM DD, YYYY") : "NA");

const formatCredentialDate = (value) => {
  if (!value) return "Uploaded document";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "Uploaded document" : date.toLocaleDateString();
};

const formatCredentialMeta = (credential) => {
  const parts = [];
  if (credential?.fileType) parts.push(String(credential.fileType).toUpperCase());
  if (credential?.fileSize) {
    const sizeInMb = Number(credential.fileSize) / (1024 * 1024);
    parts.push(`${sizeInMb.toFixed(sizeInMb >= 10 ? 0 : 1)} MB`);
  }
  return parts.join(" · ");
};

const getFileExtension = (value = "") => {
  const str = String(value).toLowerCase();
  const idx = str.lastIndexOf(".");
  return idx >= 0 ? str.slice(idx + 1) : "";
};

const formatCount = (value) => {
  const number = Number(value) || 0;
  if (number >= 1000) return `${(number / 1000).toFixed(number >= 10000 ? 0 : 1)}k`;
  return number;
};

const isNotDeletedRecord = (item) =>
  !(item?.Deleted || item?.IsDeleted || item?.isDeleted || item?.deleted);

const getSocialLinks = (socialProfiles = []) => {
  const map = socialProfiles
    .filter(Boolean)
    .reduce((acc, item) => {
      const code = item?.SocialMediaType?.SocialMediaTypeCode;
      const url = `${item?.SocialMediaType?.SocialMediaTypeURL || ""}${item?.SocialMediaTypeSlug || ""}`;
      if (code && url) acc[code] = url;
      return acc;
    }, {});

  return [
    {
      key: "FB",
      label: "Facebook",
      enabled: Boolean(map.FB),
      href: map.FB,
      icon: <BsFacebook className="emp-new-3d-social-icon emp-new-3d-social-icon--facebook" />,
    },
    {
      key: "LI",
      label: "LinkedIn",
      enabled: Boolean(map.LI),
      href: map.LI,
      icon: <BsLinkedin className="emp-new-3d-social-icon emp-new-3d-social-icon--linkedin" />,
    },
    {
      key: "GH",
      label: "GitHub",
      enabled: Boolean(map.GH),
      href: map.GH,
      icon: <GrGithub className="emp-new-3d-social-icon emp-new-3d-social-icon--github" />,
    },
    {
      key: "SO",
      label: "Stack Overflow",
      enabled: Boolean(map.SO),
      href: map.SO,
      icon: <BsStackOverflow className="emp-new-3d-social-icon emp-new-3d-social-icon--stackoverflow" />,
    },
  ];
};

export default function Resume3d() {
  const dispatch = useDispatch();
  const location = useLocation();

  const [educationHistory, setEducationHistory] = useState([]);
  const [credentials, setCredentials] = useState([]);
  const [selectedCredentialIds, setSelectedCredentialIds] = useState([]);
  const [credentialSearch, setCredentialSearch] = useState("");
  const [credentialPreview, setCredentialPreview] = useState({ open: false, url: "", title: "" });
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [isFollowed, setIsFollowed] = useState(false);
  const [imagesGenrated] = useState(false);
  const [error] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [currentRecords, setCurrentRecords] = useState([]);
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const [imageError, setImageError] = useState(false);
  const [followersCount, setFollowersCount] = useState(0);
  const [userProfileState, setUserProfileState] = useState(() => JSON.parse(localStorage.getItem("userProfile") || "{}"));

  const resume = useSelector((state) => state.getResume3dReducer.resumedetails);
  const resumeHide = useSelector((state) => state?.getResume3dReducer?.resumedetails?.skilllisting);
  const loading = useSelector((state) => state.getResume3dReducer.loading);
  const userSKillListing = useSelector((state) => state.oneUserskillListingReducer.skillListings);
  const Pdetails = useSelector((state) => state.getProfileDetailsReducer.details);
  const followSuccess = useSelector((state) => state.followUnFollowReducer.follow_success);
  const unFollowSuccess = useSelector((state) => state.followUnFollowReducer.unfollow_success);
  const removePvtResponse = useSelector((state) => state.getProfileDetailsReducer.RemoveTalentPrivate);
  const removePvtLoading = useSelector((state) => state.getProfileDetailsReducer?.loadingPrivate);

  const id = location?.state?.candidateid;
  const showBackButton = location?.state?.fromSpecificRedirect;

  const profile = resume?.profile?.Profiles || {};
  const accountId = resume?.profile?.AccountId;
  const credentialUserId =
    userSKillListing?.user_Schema?._id || Pdetails?.user_Schema?._id || resume?.profile?._id;
  const fullName = `${profile?.FirstName || ""} ${profile?.LastName || ""}`.trim() || "Candidate Name";
  const coverImageUrl = toS3Url(profile?.CoverPictureUrl) || coverImage;
  const pictureUrl = toS3Url(profile?.PictureUrl);
  const locationLabel =
    profile?.Location?.LocationWithCountry ||
    profile?.Profiles?.Location?.LocationWithCountry ||
    profile?.Location?.Location ||
    profile?.Cities?.CityName ||
    "Location not added";
  const careerSummary = profile?.Description || profile?.Objective;
  const socialLinks = getSocialLinks(profile?.ProfileSocialMedia || []);
  const showContactInfo = userSKillListing?.bid?.length > 0 || Pdetails?.user_Schema?.hired === true;
  const showCredentials = true;
  const isPrivateTagged = userProfileState?.EmployeeAssociation?.includes(
    Pdetails?.skill_listings?.[0]?.Profiles?.Accounts?.AccountId
  );

  const rating = Number(profile?.StarRating || profile?.Rating || 0);
  const stats = [
    { icon: skillListingIcon, label: "Skill listings", value: formatCount(resume?.skilllistings || 0) },
    { icon: resumeIcon2, label: "Followers", value: formatCount(followersCount) },
    { icon: resumeIcon3, label: "Views", value: formatCount(resume?.views || 0) },
    { icon: resumeIcon4, label: "Rating", value: rating ? rating.toFixed(1) : "0.0" },
    { icon: resumeIcon5, label: "Resume complete", value: `${clampPercent(resume?.profile?.Profiles?.ResumeCompletion)}%` },
  ];

  useEffect(() => {
    dispatch(viewIncrement(id));
    const handleResize = () => setWindowDimensions(getWindowDimensions());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch, id]);

  useEffect(() => {
    if (resumeHide && userSKillListing?.bid?.length === undefined) {
      dispatch(
        getOneUserSkillListing({
          skillId: resumeHide?.[0]?.SkillListingId,
          jobId: location?.state?.jobId ?? location?.search.split("jobId=")[1]?.split("&")?.[0],
        })
      );
    }
  }, [dispatch, location?.search, location?.state?.jobId, resumeHide, userSKillListing?.bid?.length]);

  useEffect(() => {
    dispatch(getResume3d({ id, forFollow: followSuccess || unFollowSuccess }));
  }, [dispatch, id, followSuccess, unFollowSuccess]);

  useEffect(() => {
    setFollowersCount(resume?.followers?.length || 0);
    setIsFollowed(Boolean(resume?.IsFollower));

    if (location?.state?.fromChat) {
      const element = document.getElementById("section-1");
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
  }, [location?.state?.fromChat, resume]);

  useEffect(() => {
    const careers = (resume?.career_records || []).filter(isNotDeletedRecord);
    const educations = (resume?.academic_records || []).filter(isNotDeletedRecord);

    setEducationHistory(educations);
    const activeCredentials = (
      resume?.Credentials ||
      resume?.credentials ||
      resume?.credentialing ||
      resume?.Credentialing ||
      resume?.TalentDocuments ||
      resume?.profile?.Profiles?.TalentDocuments ||
    []
    )
      .filter((item) => !item?.isDeleted && !item?.Deleted)
      .map((item) => ({
        ...item,
        title: item?.title || item?.CredentialDocument?.CredentialDocumentName,
        originalFileName: item?.originalFileName || item?.FileName,
        fileType: item?.fileType || getFileExtension(item?.FileName || item?.DocumentUrl),
        fileSize: item?.fileSize || item?.FileSize,
        uploadedAt: item?.uploadedAt || item?.Created,
      }));

    setCredentials(activeCredentials);
    if (careers.length) {
      const normalized = careers.map((item) => ({ ...item, year: new Date(item.StartDate).getFullYear() }));
      setCurrentRecords(normalized);
    } else {
      setCurrentRecords([]);
    }
  }, [resume]);

  const removeEmployeeAssociation = useCallback((employeeIdToRemove) => {
    const updatedEmployeeAssociation = userProfileState?.EmployeeAssociation?.filter((item) => item !== employeeIdToRemove);
    const updatedData = { ...userProfileState, EmployeeAssociation: updatedEmployeeAssociation };
    setUserProfileState(updatedData);
    return updatedData;
  }, [userProfileState]);

  useEffect(() => {
    if (removePvtResponse) {
      localStorage.setItem(
        "userProfile",
        JSON.stringify(removeEmployeeAssociation(Pdetails?.skill_listings?.[0]?.Profiles?.Accounts?.AccountId))
      );
    }
  }, [Pdetails?.skill_listings, removeEmployeeAssociation, removePvtResponse]);

  useEffect(
    () => () => {
      if (credentialPreview?.url?.startsWith("blob:")) {
        URL.revokeObjectURL(credentialPreview.url);
      }
    },
    [credentialPreview?.url]
  );

  const memoizedSkillIndex = useMemo(
    () => <SkillIndex data={resume?.skillindex} />,
    [resume?.skillindex]
  );

  const sortedIndustries = useMemo(
    () => [...(resume?.IndustryDensity || [])].sort((a, b) => clampPercent(b?.Percentage) - clampPercent(a?.Percentage)),
    [resume?.IndustryDensity]
  );

  const memoizedIndustryDensity = useMemo(() => {
    if (!sortedIndustries.length) return null;

    return <IndustryDensity data={sortedIndustries} />;
  }, [sortedIndustries]);

  const addFollowerHandler = () => {
    dispatch(addfollower({ id: accountId }));
    setFollowersCount((prev) => prev + 1);
    setIsFollowed(true);
  };

  const removeFollowerHandler = () => {
    dispatch(removefollower({ id: accountId }));
    setFollowersCount((prev) => (prev > 0 ? prev - 1 : 0));
    setIsFollowed(false);
  };

  const handleViewCredential = async (credential) => {
    const documentId = credential?._id || credential?.id;
    if (!documentId || !credentialUserId) return;
    const title = credential?.title || credential?.originalFileName || "Credential preview";
    setCredentialPreview({ open: true, url: "", title });

    try {
      const response = await getDocumentViewUrlApi(documentId, credentialUserId);
      const data = response?.data?.data;
      if (!data?.viewUrl) throw new Error("Document view URL is unavailable");

      const fileType =
        data?.document?.fileType ||
        getFileExtension(data?.document?.originalFileName || credential?.originalFileName);
      let previewUrl = data.viewUrl;
      if (fileType === "pdf") {
        const fileResponse = await fetch(data.viewUrl);
        if (!fileResponse.ok) throw new Error("Unable to load PDF preview");
        previewUrl = URL.createObjectURL(
          new Blob([await fileResponse.arrayBuffer()], { type: "application/pdf" })
        );
      }

      setCredentialPreview({
        open: true,
        url:
          fileType === "doc" || fileType === "docx"
            ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(data.viewUrl)}`
            : previewUrl,
        title: data?.document?.title || title,
      });
    } catch (error) {
      setCredentialPreview({ open: false, url: "", title: "" });
      window.alert(error?.message || "Unable to load document preview");
    }
  };

  const closeCredentialPreview = () => {
    setCredentialPreview({ open: false, url: "", title: "", fileType: "", fileUrl: "" });
  };

  const normalizedWorkHistory = useMemo(
    () =>
      currentRecords.map((item) => ({
        id: item?._id || item?.Title,
        title: item?.Title,
        companyName: item?.CompanyName,
        dateRange: `${formatDate(item?.StartDate).replace(/,/g, "")} - ${
          item?.EndDate ? formatDate(item?.EndDate).replace(/,/g, "") : "Present"
        }`,
        skills: (item?.Consultants_CareerRecordSkills || []).map((skillItem) => ({
          name: skillItem?.Skills?.SkillName,
          percent: skillItem?.SkillPercent,
        })),
        summary: (item?.Consultants_CareerRecords_Responsibilities || [])
          .flatMap((r) => normalizeDescriptionLines(r?.Description || ""))
          .join(" "),
      })),
    [currentRecords]
  );

  const normalizedCredentials = useMemo(
    () =>
      credentials.map((credential, index) => ({
        id: credential?._id || `${credential?.title || credential?.originalFileName || "credential"}-${index}`,
        title: credential?.title || "Resume",
        originalFileName: credential?.originalFileName || "Document",
        fileType: getFileExtension(credential?.originalFileName || credential?.title || ""),
        meta: formatCredentialMeta(credential) || "PDF",
        dateLabel: formatCredentialDate(credential?.uploadedAt || credential?.createdAt || credential?.updatedAt),
        raw: credential,
      })),
    [credentials]
  );

  const filteredNormalizedCredentials = useMemo(() => {
    const search = credentialSearch.trim().toLowerCase();
    if (!search) return normalizedCredentials;
    return normalizedCredentials.filter(
      (item) =>
        item.title.toLowerCase().includes(search) ||
        item.originalFileName.toLowerCase().includes(search)
    );
  }, [credentialSearch, normalizedCredentials]);

  const selectedNormalizedCredentials = normalizedCredentials.filter((item) => selectedCredentialIds.includes(item.id));

  const handleDownloadSelectedCredentials = async () => {
    if (!selectedNormalizedCredentials.length || !credentialUserId) return;

    setDownloadLoading(true);
    try {
      const response = await downloadSelectedDocumentsApi({
        userId: credentialUserId,
        documentIds: selectedNormalizedCredentials.map((item) => item.id),
      });
      const link = document.createElement("a");
      link.href = response?.data?.data?.url;
      link.download = "documents.zip";
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Failed to download selected documents", error);
      window.alert(`Download failed: ${error.message}`);
    } finally {
      setDownloadLoading(false);
    }
  };

  const handleBack = () => history.goBack();

  if ((Array.isArray(resume) && resume?.length === 0) || loading) return <Loader />;
  return (
    <main className="new-3d-resume-page emp-new-3d-page">
      <div className="new-3d-shell">
        {showBackButton ? (
          <p className="emp-new-3d-back" onClick={handleBack}>
            <img src={backButton} alt="back" />
            <span>back</span>
          </p>
        ) : null}
        {imagesGenrated ? <TopAlert display="flex" title="PDF successfully downloaded" type="success" /> : null}
        {error ? <TopAlert display="flex" title="Cannot create PDF for doc files" type="warning" /> : null}

        <section className="new-3d-cover-banner" style={{ backgroundImage: `url(${coverImageUrl})` }} />

        <section className="new-3d-hero-combined">
          <section className="new-3d-hero">
            <div className="new-3d-identity">
              <button className="new-3d-avatar" type="button" aria-label={`${fullName} avatar`}>
                {pictureUrl && !imageError && profile?.PictureUrl?.split("/")?.pop() !== "no-pic.png" ? (
                  <img src={pictureUrl} alt={fullName} onError={() => setImageError(true)} />
                ) : (
                  <span>{profile?.FirstName?.charAt(0)?.toUpperCase() || "C"}</span>
                )}
              </button>

              <div className="new-3d-profile-copy">
                <h1>{fullName}</h1>
                <p className="new-3d-location">
                  <EnvironmentOutlined />
                  {locationLabel}
                </p>
                {showContactInfo ? (
                  <div className="emp-new-3d-contact-row">
                    <span><AiOutlineMail /> {resume?.profile?.EmailAddress}</span>
                    {profile?.MobilePhone ? <span><BsTelephone /> {formatPhoneNumber(profile?.MobilePhone)}</span> : null}
                  </div>
                ) : null}
                <div className="new-3d-socials">
                  {socialLinks.map((item) => (
                    <button
                      key={item.key}
                      className={`new-3d-social-button ${item.enabled ? "new-3d-social-button--enabled" : "new-3d-social-button--disabled"}`}
                      disabled={!item.enabled}
                      aria-disabled={!item.enabled}
                      title={item.label}
                      type="button"
                      onClick={() => item.enabled && window.open(item.href, "_blank")}
                    >
                      {item.icon}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="new-3d-hero-actions">
              {isFollowed ? (
                <button className="new-3d-outline-button new-3d-follow-button" type="button" onClick={removeFollowerHandler}>
                  Following
                </button>
              ) : (
                <button className="new-3d-cover-action-primary new-3d-follow-button" type="button" onClick={addFollowerHandler}>
                  Follow
                </button>
              )}

              {userProfileState?.EmployeeAssociation?.includes(id) ? (
                <Button className={windowDimensions.width > 991 ? "resume-web" : "resume-mobile"} onClick={() => setShowConfirmationModal(true)}>
                  {removePvtLoading ? <Spin indicator={<LoadingOutlined style={{ fontSize: 20, color: "#fff" }} spin />} /> : "Remove from private marketplace"}
                </Button>
              ) : null}
            </div>
          </section>

          {isPrivateTagged ? <div className="emp-new-3d-private-tag"><PrivateTagSkillListing /></div> : null}

          <div className="new-3d-career-inline">
            <h3>Career Summary</h3>
            <p>{careerSummary || "No career summary added yet."}</p>
          </div>
        </section>

        <section className="new-3d-stat-list" aria-label="Resume statistics">
          {stats.map((stat) => (
            <article className="new-3d-stat-card" key={stat.label}>
              <span className="new-3d-stat-icon"><img src={stat.icon} alt="" /></span>
              <div>
                <strong>{stat.value}</strong>
                <span>{stat.label}</span>
              </div>
            </article>
          ))}
        </section>

        <section className="new-3d-panel new-3d-legacy-skill-index">
          <div className="new-3d-section-title">
            <div className="new-3d-section-heading">
              <span className="new-3d-section-icon"><GlobalOutlined /></span>
              <h2>Skill index</h2>
            </div>
          </div>
          {memoizedSkillIndex}
        </section>

        <CareerHistory items={normalizedWorkHistory} />

        {memoizedIndustryDensity ? (
          <section className="new-3d-panel new-3d-industry-density-section">
            <div className="new-3d-section-title">
              <div className="new-3d-section-heading">
                <span className="new-3d-section-icon"><GlobalOutlined /></span>
                <h2>Industry density</h2>
              </div>
            </div>
            {memoizedIndustryDensity}
          </section>
        ) : null}

        <section className="new-3d-panel">
          <div className="new-3d-section-title">
            <div className="new-3d-section-heading">
              <span className="new-3d-section-icon"><BookOutlined /></span>
              <h2>Education</h2>
            </div>
          </div>

          {educationHistory.length ? (
            <div className="resume-3d-education-grid">
              {educationHistory.map((item, index) => (
                <article className="resume-3d-education-tile" key={`${item?._id || item?.YearCompleted}-${index}`}>
                  <span className="resume-3d-education-icon"><BookOutlined /></span>
                  <div className="resume-3d-education-copy">
                    <h3>{item?.Courses?.CourseName || "Education not specified"}</h3>
                    <p>{item?.Schools?.SchoolName || "School not specified"}</p>
                    <strong>{item?.YearCompleted || "Year not specified"}</strong>
                  </div>
                </article>
              ))}
            </div>
          ) : (
            <div className="new-3d-empty">No education added yet</div>
          )}
        </section>

        {showCredentials ? (
          <Credentialing
            items={normalizedCredentials}
            filteredItems={filteredNormalizedCredentials}
            selectedIds={selectedCredentialIds}
            searchValue={credentialSearch}
            onSearchChange={setCredentialSearch}
            onToggleSelected={(id) =>
              setSelectedCredentialIds((prev) =>
                prev.includes(id) ? prev.filter((selectedId) => selectedId !== id) : [...prev, id]
              )
            }
            onDownloadSelected={handleDownloadSelectedCredentials}
            downloadLoading={downloadLoading}
            onView={async (item) => handleViewCredential(item.raw)}
          />
        ) : null}

        <Modal
          open={credentialPreview.open}
          onCancel={closeCredentialPreview}
          footer={null}
          centered
          width="min(1100px, 92vw)"
          title={credentialPreview.title}
          destroyOnClose
          className="new-3d-credential-preview-modal"
        >
          {credentialPreview.url ? (
            <iframe
              title={credentialPreview.title}
              src={credentialPreview.url}
              className="new-3d-credential-preview-frame"
            />
          ) : (
            <div style={{ minHeight: "60vh", display: "grid", placeItems: "center" }}>
              <Spin />
            </div>
          )}
        </Modal>

        <PopupModal
          id={id}
          show={showConfirmationModal}
          onClose={() => setShowConfirmationModal(false)}
          popUpTrue={false}
          setpopUpTrue={() => {}}
          absAccountId={userProfileState?.MasterAccountId || userProfileState?.AccountId}
        />
      </div>
    </main>
  );
}
